<template>
  <div class="user-avatar" :class="computedClasses" @click="onClick">
    <vue-avatar :name="name" :url="url" rounded block />
  </div>
</template>

<script>
import VueAvatar from "@vcraescu/vue-avatar";

const SIZE_XS = "xs";
const SIZE_SM = "sm";
const SIZE_MD = "md";
const SIZE_LG = "lg";

export default {
  name: "AppAvatar",
  components: { VueAvatar },
  props: {
    url: {
      type: String,
      required: false,
      default: null,
    },
    name: {
      type: String,
      required: true,
    },
    size: {
      type: String,
      required: false,
      default: SIZE_MD,
      validator: size =>
        [SIZE_XS, SIZE_SM, SIZE_MD, SIZE_LG].indexOf(size) >= 0,
    },
    block: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    computedClasses() {
      return { [`avatar-${this.size}`]: this.size && !this.block };
    },
  },
  methods: {
    onClick(event) {
      this.$emit("click", event);
    },
  },
};
</script>

<style lang="scss" scoped>
.user-avatar {
  display: inline-block;
  border-radius: 50%;

  &.avatar-xs {
    height: 2.12rem;
    width: 2.12rem;
  }
  &.avatar-sm {
    height: 4rem;
    width: 4rem;
  }

  &.avatar-md {
    height: 5rem;
    width: 5rem;
  }

  &.avatar-lg {
    height: 6.25rem;
    width: 6.25rem;
  }
}
</style>
